// extracted by mini-css-extract-plugin
export default {"actionButton":"setPasswordSuccessPage_actionButton__s39WY"};